/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForCostProcessing extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForCostProcessing.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForCostProcessing>): ProgressDetailsForCostProcessing {
        let obj = Object.assign(new ProgressDetailsForCostProcessing(), model);
        ProgressDetailsForCostProcessing.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForCostProcessing>): ProgressDetailsForCostProcessing {
        if (!model) return null;
        return ProgressDetailsForCostProcessing.newInstance(<ProgressDetailsForCostProcessing> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForCostProcessing) {
        if (!obj) return;

        models.ProgressDetailsForCostProcessing.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForCostProcessing): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForCostProcessing.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.processing_memory) {
            models.BaseCostProcessingMemory.fixupPrototype(this.processing_memory);
        }
    }

    /**
     * Processing history
     */
    processing_memory: models.BaseCostProcessingMemory;

}
